import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@geefamily/api';

/**
 * Shared TanStack Query configuration.
 *
 * The defaults matter more than they look: retrying a 404 or a 403 wastes three
 * round-trips and delays the error the user needs to see, so retries are
 * restricted to failures that can plausibly succeed on a second attempt.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (error instanceof ApiError && !error.isRetryable) {
            return false;
          }

          return failureCount < 2;
        },
        retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
      },
      mutations: {
        // A mutation that failed may have already been applied server-side;
        // retrying it automatically risks doing the thing twice.
        retry: false,
      },
    },
  });
}
